var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f8f8;}.cls-2{fill:none;}.cls-3{fill:#282c67;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    className: "cls-1",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.36,
    y: 13.24,
    width: 33.28,
    height: 22.19,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.64,13.24H10.36a2,2,0,0,0-2,2V33.43a2,2,0,0,0,2,2H39.64a2,2,0,0,0,2-2V15.24A2,2,0,0,0,39.64,13.24Zm-2,2L25,27.92,12.32,15.24ZM10.36,33.43V16.11L25,30.75,39.64,16.11V33.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cf1792d5e0ab8b388111c7eb96a6a652.svg";
export { ForwardRef as ReactComponent };